import { persistStore } from 'redux-persist';
import { store } from '~shared/store';
// Persisted slices MUST be injected into the root reducer before
// persistStore() runs (#3296 root cause): a slice injected in the gap
// between the synchronous PERSIST dispatch and the async REHYDRATE
// materializes its initialState during the REHYDRATE reduction itself,
// which autoMergeLevel1 mistakes for a pre-rehydrate modification — and it
// then SKIPS restoring the slice's persisted state. That dropped the
// persisted sessionId on every full page load: /success ran on a fresh
// session and the GTM purchase event never fired (and carts were lost on
// reloads). Importing the slice here pins the safe ordering no matter who
// else imports it when. Slices injected lazily AFTER rehydration (route
// modules) are safe either way — combineSlices preserves their restored
// state as unknown keys until they inject.
import '~entities/session/model/session.slice';

export const persistor = persistStore(store);
